import { SurveyQuestionDropdown } from 'survey-react-ui';
import type { ItemValue } from 'survey-core';
import { createRef, RefObject } from 'react';
import { invoke } from 'lodash';
import classNames from 'classnames';
import { IonNote, IonSelect, isPlatform } from '@ionic/react';

import { SurveyDropdownItem } from '../SurveyDropdownItem/SurveyDropdownItem';
import selectStyles from '../../Form/FormSelect/FormSelect.css?raw';

import inputStyles from '../../Form/_styles/input.module.scss';
import formControlStyles from '../../Form/FormControl/FormControl.module.scss';
import styles from './SurveyDropdown.module.scss';

export class SurveyDropdown extends SurveyQuestionDropdown {
  private elementRef: RefObject<HTMLIonSelectElement>;

  constructor(props: any) {
    super(props);
    this.elementRef = createRef();
  }

  protected renderElement(): JSX.Element | null {
    const invalid = this.question.errors.some(({ visible }) => visible);

    return (
      <div className={formControlStyles.default} style={{ width: '100%' }}>
        <IonSelect
          ref={this.elementRef}
          fill="outline"
          labelPlacement="stacked"
          label={this.question.title}
          id={this.question.inputId}
          onIonChange={({ detail: { value } }) => {
            this.question.value = value;
          }}
          className={classNames(inputStyles.root, {
            'ion-invalid': invalid,
            'ion-touched': invalid,
          })}
          interface={isPlatform('desktop') ? 'popover' : 'action-sheet'}
        >
          {this.question.visibleChoices.map(
            (item: ItemValue, index: number) => (
              <SurveyDropdownItem
                key={'item' + index}
                item={item}
                question={this.question}
              />
            )
          )}
        </IonSelect>
        {invalid && (
          <IonNote className={classNames(styles.note, styles.error)}>
            {invoke(this.question, ['errors', 0, 'getText'])}
          </IonNote>
        )}
      </div>
    );
  }

  componentDidMount(): void {
    super.componentDidMount();
    const style = document.createElement('style');
    style.innerHTML = selectStyles;
    this.elementRef.current.shadowRoot.appendChild(style);
  }
}
